import pluck from '../utilities/pluck';

const selectIsScheduling = pluck('isScheduling');

export default selectIsScheduling;
